import React, { useState, useEffect, useRef } from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function ProgressRender({ node, isLiveMode }) {
  const content = node.content || {};
  
  const title = content.title || '5G Ausbau';
  const percentage = parseInt(content.percentage, 10) || 80;
  const showPercentage = content.showPercentage !== 'false';
  const barColor = content.barColor || 'var(--tef-primary, #00A9E0)';
  
  const containerRef = useRef(null);
  const [currentWidth, setCurrentWidth] = useState(isLiveMode ? 0 : percentage);

  useEffect(() => {
    if (!isLiveMode) return;
    
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        // Kurzer Delay für besseren visuellen Effekt
        setTimeout(() => setCurrentWidth(percentage), 200);
        observer.disconnect();
      }
    }, { threshold: 0.1 });

    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, [isLiveMode, percentage]);

  return (
    <div ref={containerRef} style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: '15px', fontWeight: '600', color: '#f8fafc' }}>{title}</span>
        {showPercentage && <span style={{ fontSize: '14px', color: '#cbd5e1' }}>{percentage}%</span>}
      </div>
      
      {/* Track */}
      <div style={{ 
        width: '100%', 
        height: '8px', 
        background: 'rgba(255,255,255,0.1)', 
        borderRadius: '4px',
        overflow: 'hidden'
      }}>
        {/* Fill */}
        <div style={{
          height: '100%',
          width: `${currentWidth}%`,
          background: barColor,
          borderRadius: '4px',
          transition: 'width 1.5s cubic-bezier(0.22, 1, 0.36, 1)' // easeOutQuint
        }} />
      </div>
    </div>
  );
}

registry.register('Progress', {
  label: 'Fortschrittsbalken',
  icon: '📊', 
  category: 'advanced',
  component: ProgressRender,
  
  defaultProps: {
    content: {
      title: 'Erfüllungsquote WKZ',
      percentage: '75',
      showPercentage: 'true',
      barColor: '#00A9E0'
    },
    style: {
      desktop: {
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Fortschritt',
          fields: [
            { name: 'content.title', label: 'Titel / Skill', type: 'text' },
            { name: 'content.percentage', label: 'Prozent (0-100)', type: 'text' },
            { name: 'content.showPercentage', label: 'Prozentwert rechts zeigen?', type: 'select', options: ['true', 'false'] }
          ]
        },
        {
          title: 'Styling',
          fields: [
            { name: 'content.barColor', label: 'Balken-Farbe', type: 'color' }
          ]
        }
      ]
    }
  ]
});
